// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import LazyImage from "@insite/mobius/LazyImage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import { LazyImageProps } from "@store/MobiusOverrides/LazyImage/LazyImage";
import constants from "@store/constants";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    page: getCurrentPage(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface BlogPageAuthorStyles {
    title?: TypographyProps;
    dateAndAuthorWrapper?: InjectableCss;
    dateAndAuthorContainedWrapper?: InjectableCss;
    dateAndAuthorContainer?: GridContainerProps;
    authorImageWrapper?: InjectableCss;
    authorImage?: LazyImageProps;
    authorNameText?: TypographyProps;
    authorNameWrapper?: InjectableCss;
    authorTitleText?: TypographyProps;
    publishDateText?: TypographyProps;
}

export const blogPageAuthorStyles: BlogPageAuthorStyles = {
    title: {
        variant: "headerTertiary",
        as: "h2",
    },
    dateAndAuthorContainer: {
        css: css`
            display: flex;
            padding: ${pxToRem(0, 0, 24)};
        `,
    },
    authorImageWrapper: {
        css: css`
            margin-right: ${pxToRem(8)};
        `,
    },
    authorImage: {
        css: css`
            max-width: ${pxToRem(100)};
            max-height: ${pxToRem(100)};
            width: auto;
            height: auto;
            align-items: center;

            ${breakpoint("md")} {
                max-width: ${pxToRem(150)};
                max-height: ${pxToRem(150)};
            }
        `,
    },
    authorNameWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
        `,
    },
    authorNameText: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    authorTitleText: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.small};
            margin-bottom: ${pxToRem(8)};
        `,
    },
};

const styles = blogPageAuthorStyles;

const BlogPageTitleAndAuthor = ({ page }: Props) => {
    if (!page) {
        return null;
    }

    const {
        fields: { title, authorImage, authorName, authorTitle, publishDate },
    } = page;

    return (
        <StyledWrapper {...styles.dateAndAuthorWrapper}>
            <StyledWrapper {...styles.dateAndAuthorContainedWrapper}>
                <Typography {...styles.title}>{title}</Typography>
                <StyledWrapper {...styles.dateAndAuthorContainer}>
                    {authorImage && (
                        <StyledWrapper {...styles.authorImageWrapper}>
                            <LazyImage {...styles.authorImage} src={authorImage} />
                        </StyledWrapper>
                    )}
                    <StyledWrapper {...styles.authorNameWrapper}>
                        {authorName && <Typography {...styles.authorNameText}>{authorName}</Typography>}
                        {authorTitle && <Typography {...styles.authorTitleText}>{authorTitle}</Typography>}
                        {publishDate && (
                            <Typography {...styles.publishDateText}>
                                <LocalizedDateTime
                                    dateTime={new Date(publishDate)}
                                    options={{ year: "numeric", month: "long", day: "numeric" }}
                                />
                            </Typography>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BlogPageTitleAndAuthor),
    definition: {
        group: constants.widgetGroup.blogPage as any,
        allowedContexts: [constants.pageType.blogPost] as any,
    },
};

export default widgetModule;
